import { tokens } from '@hotjar/hotsauce';

import { Icon } from '@hotjar/webapp/components/Icon';
import { getIconColor } from '@hotjar/webapp/features/Feedback/EmotionIcon/icons/settings';

const emotionMap = {
  0: {
    color: tokens.color.neutral_500,
    iconName: 'emotion-neutral',
  },
  1: {
    color: getIconColor(0),
    iconName: 'emotion-angry',
  },
  2: {
    color: getIconColor(1),
    iconName: 'emotion-sad',
  },
  3: {
    color: getIconColor(2),
    iconName: 'emotion-neutral',
  },
  4: {
    color: getIconColor(3),
    iconName: 'emotion-happy',
  },
  5: {
    color: getIconColor(4),
    iconName: 'emotion-love',
  },
} as const;

type IconIndex = keyof typeof emotionMap;

interface SentimentIconProps {
  average: number;
  className?: string;
  size?: number;
}

function roundAverage(average: number): IconIndex {
  const rounded = Math.round(average);

  if (rounded > 5) {
    return 5;
  }

  if (rounded < 0) {
    return 0;
  }

  // NOTE: we're narrowing the type manually here, TypeScript cannot tell if
  // it's true or not, it just trusts us; make sure we don't break that trust
  return rounded as IconIndex;
}

export function SentimentIcon({ average, className, size = 38 }: SentimentIconProps): JSX.Element {
  const roundedAvg = roundAverage(average);

  const { color, iconName } = emotionMap[roundedAvg];

  return <Icon className={className} color={color} icon={iconName} size={size} />;
}
